import clsx from 'clsx'
import React from 'react'

import { Icon } from '../'

import './ThemeIcon.scss'

const ThemeIcon = ({ className, name, size, ...props }) => {
   return (
      <Icon
         className={clsx('ThemeIcon', className)}
         name={name}
         size={size}
         {...props}
      />
   )
}

export default ThemeIcon
